import {createTheme} from "@mui/material/styles";
import {ruRU} from "@mui/x-date-pickers";
import "moment/locale/ru";

const theme = createTheme(
  {
    //mixins:{toolbar:{minHeight:131}},
    mixins: {
      toolbar: {
        minHeight: 82,

        "@media screen and (max-width: 768px)": {
          minHeight: 44,
        }

      }
    },
    palette: {
      mainButton: {
        main: "#000",
        light: "#101010",
        dark: "#0E0F0F",
        contrastText: "#FFF",
        blue: "#689ADB",
        darkBlue: "#173760",
        thinButtonActivity: "#FFF0F3",
        extralightButtonActivity: "#FFCCD5",
        lightButtonActivity: "#FFB3C1",
        normalButtonActivity: "#FF8FA3",
        mediumButtonActivity: "#FF758F",
        semiboldButtonActivity: "#FF4D6D",
        red: "#CA0202",
      },
      secondary: {
        main: "#C2C2C2",
        light: "#F6F6F6",
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
        mobile: 768,
      },
    },
  },
  ruRU
);

export default theme;
